// Globals
import { useTranslation } from 'react-i18next';

// Components
import { Form, FormItem, useForm } from '@/components';
import { Button, Checkbox, Input, PasswordInput, Select } from '@/ui';

// Helpers
import { getLegalTypeOptions, getStatusOptions } from '../../helpers/getOptions';
import { CashRegisterFormFields, TCashRegisterFormValues } from '../../helpers/types';
import { StyledSectionSubtitle } from '../Styled';

type TCashRegisterFormProps = {
  onSubmit?: (values: TCashRegisterFormValues) => void;
  isLoading?: boolean;
  initialValues?: Partial<TCashRegisterFormValues>;
  isEdit?: boolean;
};

const CashRegisterForm = ({ onSubmit, isLoading, initialValues, isEdit }: TCashRegisterFormProps) => {
  const { t } = useTranslation(['financialSettings']);
  const [form] = useForm();

  const required = [{ required: true, message: t('validation_required') }];
  const secretPlaceholder = isEdit ? t('secret_keep_hint') : undefined;

  return (
    <Form form={form} onFinish={onSubmit} initialValues={initialValues}>
      <FormItem label={t('field_name')} name={CashRegisterFormFields.NAME} rules={required}>
        <Input placeholder={t('field_name_placeholder')} />
      </FormItem>
      <FormItem label={t('field_number')} name={CashRegisterFormFields.NUMBER}>
        <Input />
      </FormItem>
      <FormItem label={t('field_fiscal_number')} name={CashRegisterFormFields.FISCAL_NUMBER}>
        <Input />
      </FormItem>
      <FormItem label={t('field_legal_type')} name={CashRegisterFormFields.LEGAL_TYPE} rules={required}>
        <Select options={getLegalTypeOptions(t)} size="middle" />
      </FormItem>
      <FormItem label={t('field_status')} name={CashRegisterFormFields.IS_ACTIVE} rules={required}>
        <Select options={getStatusOptions(t)} size="middle" />
      </FormItem>
      <FormItem label={t('field_is_virtual')} name={CashRegisterFormFields.IS_VIRTUAL} valuePropName="checked">
        <Checkbox />
      </FormItem>
      <FormItem label={t('field_fiscal_department')} name={CashRegisterFormFields.FISCAL_DEPARTMENT}>
        <Input placeholder={t('field_fiscal_department_placeholder')} />
      </FormItem>
      <FormItem label={t('field_license_key')} name={CashRegisterFormFields.LICENSE_KEY}>
        <PasswordInput placeholder={secretPlaceholder} autoComplete="new-password" />
      </FormItem>

      <StyledSectionSubtitle>{t('section_cashier')}</StyledSectionSubtitle>

      <FormItem label={t('field_cashier_name')} name={CashRegisterFormFields.CASHIER_NAME} rules={required}>
        <Input />
      </FormItem>
      <FormItem label={t('field_cashier_login')} name={CashRegisterFormFields.CASHIER_LOGIN} rules={required}>
        <Input autoComplete="off" />
      </FormItem>
      <FormItem label={t('field_cashier_pin_code')} name={CashRegisterFormFields.CASHIER_PIN_CODE}>
        <PasswordInput placeholder={secretPlaceholder} autoComplete="new-password" />
      </FormItem>

      <Button htmlType="submit" block loading={isLoading} type="primary">
        {t('button_common_save', { ns: 'common' })}
      </Button>
    </Form>
  );
};

export default CashRegisterForm;
